module.exports = __webpack_public_path__ + "img/bg_login.cea491e9.jpg";